"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Board_1 = require("./Board");
exports.Board = Board_1.default;
exports.testCheck = Board_1.testCheck;
var state_1 = require("./state");
exports.getDefaultBoardState = state_1.default;
exports.getRandomBoardState = state_1.getRandomBoardState;
var pieces_1 = require("./pieces");
exports.registerPieceType = pieces_1.registerPieceType;
exports.getPieceType = pieces_1.getPieceType;
exports.King = pieces_1.King;
exports.Queen = pieces_1.Queen;
exports.Bishop = pieces_1.Bishop;
exports.Knight = pieces_1.Knight;
exports.Rook = pieces_1.Rook;
exports.Pawn = pieces_1.Pawn;
var constantes_1 = require("./constantes");
exports.White = constantes_1.White;
exports.Black = constantes_1.Black;
exports.WIDTH = constantes_1.WIDTH;
exports.HEIGHT = constantes_1.HEIGHT;
var AI_1 = require("./AI");
exports.AI = AI_1.default;



/*****************
 ** WEBPACK FOOTER
 ** ../brchess-core/dist/index.js
 ** module id = 7
 ** module chunks = 0
 **/